import styled from "styled-components";

// Styled components
export const StepBadge = styled.div`
  display: inline-flex;
  padding: 2px 10px;
  border-radius: 20px;
  border: 1px solid #e9eaeb;
  background: #fafafa;
  color: #414651;
  text-align: center;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
export const SignupFlowWrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: var(--signup-flow-justify-content, space-between);
  height: 100%;
  max-height: 100vh;
  max-width: 680px;
  width: 100%;
  margin: 3.5rem auto 0;
  font-family: "Geist", sans-serif;

  /* Ensure all child elements inherit Geist font */
  * {
    font-family: "Geist", sans-serif;
  }

  @media (max-width: 375px) {
    padding: 0 10px;
  }
`;
export const SignupFlowContent = styled.div`
  flex: var(--signup-flow-flex, 1);
  margin-bottom: 2rem;
  h1 {
    font-size: 24px;
    font-weight: 500;
    color: #181d27;
    margin-bottom: 8px;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    border-bottom: 1px solid #e9eaeb;

    h3 {
      color: #181d27;
      font-family: "Geist", sans-serif;
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
      margin: 0;
    }
    p {
      color: #535862;
      font-family: "Geist", sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 2rem;
    }
  }
`;

export const SignupFlowFooter = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 2rem;
`;
export const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
